import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/app/store';
import { fetchDocumentsWithFilters } from '@/features/documents/documentsThunks';
import { resetDocumentsPagination } from '@/features/documents/documentsSlice';
import { FilterValues } from '@/types/document.types';

export const useDocumentFilters = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [filters, setFilters] = useState<FilterValues>({
        name: '',
        tag: '',
        date: null,
        editor: ''
    });

    const applyFilters = useCallback((newFilters: FilterValues) => {
        setFilters(newFilters);
        const filterParams = {
            name: newFilters.name || undefined,
            tag: newFilters.tag || undefined,
            date: newFilters.date ? newFilters.date.toISOString() : undefined,
            editor: newFilters.editor || undefined,
        };
        dispatch(resetDocumentsPagination());
        dispatch(fetchDocumentsWithFilters(filterParams));
    }, [dispatch]);

    return {
        filters,
        applyFilters
    };
};
